import React from 'react';
import { getIn, useFormikContext } from 'formik';
import { DateInput, IDateInputProps, IDateInputValue } from '../DateInput';
import { DateTime } from 'luxon';

interface IIDateField extends Partial<IDateInputProps> {
  name: string;
  preventPastDates?: boolean;
  preventFutureDates?: boolean;
  onlyPastDates?: boolean;
}

//FYI: this simplifies integration with Formik. See README
export const DateField: React.FC<IIDateField> = ({ name, preventPastDates, preventFutureDates, onlyPastDates, ...rest }) => {
  const formik = useFormikContext();
  const onChange = (value: IDateInputValue) => {
    formik.setFieldTouched(name as never);
    formik.setFieldValue(name as never, value.value);
    if (rest.onChange) {
      rest.onChange(value);
    }
  };

  const value = getIn(formik.values, name);
  const errorText =
    (!!formik.submitCount || !!getIn(formik.touched, name)) && !!getIn(formik.errors, name)
      ? getIn(formik.errors, name)
      : null;

  let calculatedMinDate = rest.minDate;
  let calculatedMaxDate = rest.maxDate;

  if (preventPastDates && !calculatedMinDate) {
    calculatedMinDate = DateTime.now().startOf('day').toISODate();
  }

  if (preventFutureDates && !calculatedMaxDate) {
    calculatedMaxDate = DateTime.now().endOf('day').toISODate();
  }

  if (onlyPastDates && !calculatedMaxDate) {
    calculatedMaxDate = DateTime.now().minus({ days: 1 }).endOf('day').toISODate();
  }

  return (
    <DateInput
      {...rest}
      value={value}
      onChange={onChange}
      errorText={errorText}
      minDate={calculatedMinDate}
      maxDate={calculatedMaxDate}
      data-test-id={rest['data-test-id'] || name}
    />
  );
};
